import { actionCreator } from 'utils';
import * as ShippingTypeTypes from '../types/shippingTypeTypes';

// L O A D   S H I P P I N G   T Y P E
export function loadShippingType() {
    return {
        type: ShippingTypeTypes.LOAD_SHIPPING_TYPE,
    };
}

export function loadShippingTypeRes(data) {
    return {
        type: actionCreator(ShippingTypeTypes.LOAD_SHIPPING_TYPE, 'res'),
        data,
    };
}

export function loadShippingTypeErr() {
    return {
        type: actionCreator(ShippingTypeTypes.LOAD_SHIPPING_TYPE, 'err'),
    };
}
// L O A D   S H I P P I N G   T Y P E

// S E T   S H I P P I N G   T Y P E   P A G I N A T I O N
export function setShippingTypePagination(key, pagination) {
    return {
        type: ShippingTypeTypes.SET_SHIPPING_TYPE_PAGINATION,
        key,
        pagination,
    };
}
// S E T   S H I P P I N G   T Y P E   P A G I N A T I O N

// A D D   S H I P P I N G   T Y P E
export function addShippingType(data) {
    return {
        type: ShippingTypeTypes.ADD_SHIPPING_TYPE,
        data,
    };
}

export function addShippingTypeRes() {
    return {
        type: actionCreator(ShippingTypeTypes.ADD_SHIPPING_TYPE, 'res'),
    };
}

export function addShippingTypeErr() {
    return {
        type: actionCreator(ShippingTypeTypes.ADD_SHIPPING_TYPE, 'err'),
    };
}
// A D D   S H I P P I N G   T Y P E

// E D I T   S H I P P I N G   T Y P E
export function editShippingType(data) {
    return {
        type: ShippingTypeTypes.EDIT_SHIPPING_TYPE,
        data,
    };
}

export function editShippingTypeRes() {
    return {
        type: actionCreator(ShippingTypeTypes.EDIT_SHIPPING_TYPE, 'res'),
    };
}

export function editShippingTypeErr() {
    return {
        type: actionCreator(ShippingTypeTypes.EDIT_SHIPPING_TYPE, 'err'),
    };
}
// E D I T   S H I P P I N G   T Y P E

// L O A D   E D I T A B L E   S H I P P I N G   T Y P E
export function loadEditableShippingType(id) {
    return {
        type: ShippingTypeTypes.LOAD_EDITABLE_SHIPPING_TYPE,
        id,
    };
}

export function loadEditableShippingTypeRes(data) {
    return {
        type: actionCreator(ShippingTypeTypes.LOAD_EDITABLE_SHIPPING_TYPE, 'res'),
        data,
    };
}

export function loadEditableShippingTypeErr() {
    return {
        type: actionCreator(ShippingTypeTypes.LOAD_EDITABLE_SHIPPING_TYPE, 'err'),
    };
}
// L O A D   E D I T A B L E   S H I P P I N G   T Y P E

// S E T   E D I T A B L E   S H I P P I N G   T Y P E   D A T A
export function setEditableShippingTypeData(data) {
    return {
        type: ShippingTypeTypes.SET_EDITABLE_SHIPPING_TYPE_DATA,
        data,
    };
}
// S E T   E D I T A B L E   S H I P P I N G   T Y P E   D A T A
